import { 
  Home, 
  Users, 
  FileText, 
  CreditCard, 
  BarChart2, 
  Settings, 
  ChevronRight, 
  BookOpen,
  ArrowRightLeft,
  ShoppingBag,
  ShoppingCart,
  BarChart,
  Search,
  Heart,
  HelpCircle,
  Files,
  Combine,
  Group,
  FileUp,
  Sheet,
  Truck,
  BadgePercent,
  HandCoins,
  WalletCards,
  CalendarCheck,
  LogOut,
  PiggyBank,
  User,
  X,
  Grid3X3,
  TrendingUp,
  Car,
  DollarSign,
  Shield,
  Calculator,
  Scale
} from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";

export default function BottomNavBar({ activeTab, setActiveTab }) {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Main bottom nav items (always visible)
  const navItems = [
    { name: 'Home', icon: <Home size={22} />, key: 'home', path: '/home' },
    //{ name: 'Categories', icon: <Grid3X3 size={22} />, key: 'members', path: '' }, // Opens modal
    { name: 'Shop', icon: <ShoppingBag size={22} />, key: 'shop', path: '/shop' }, // Opens modal
    { name: 'Wishlist', icon: <Heart size={22} />, key: 'savings', path: '/Wishlist' },
    { name: 'Account', icon: <Users  size={22} />, key: 'menu', path: '/myAccount' }, // Opens full premium menu
  ];

  // Full premium menu items (all items from sidebar)
  const premiumMenuItems = [
    // Main Menu
    { label: 'Dashboard', path: '/dashboard', icon: <Home size={24} />, color: 'bg-blue-600' },

    // SMS Communication
    { label: 'SMS Communication', path: '/SMS', icon: <BookOpen size={24} />, color: 'bg-teal-500' },

    // ─────────────────────────────────────────────
    // Sacco A Members
    { label: 'Add New Member (Sacco A)', path: '/NewMember/Sacco-A', icon: <Users size={24} />, color: 'bg-green-500' },
    { label: 'Sacco A - Active', path: '/Members/Sacco-A/Details', icon: <Users size={24} />, color: 'bg-emerald-600' },
    { label: 'Sacco A In-active', path: '/InactiveMembers/Sacco-A/Details', icon: <Users size={24} />, color: 'bg-red-500' },

    // Sacco B Members
    { label: 'Add New Member (Sacco B)', path: '/NewMember/Sacco-B', icon: <Users size={24} />, color: 'bg-green-500' },
    { label: 'Sacco B - Active', path: '/Members/Sacco-B/Details', icon: <Users size={24} />, color: 'bg-emerald-600' },
    { label: 'Sacco B In-active', path: '/InactiveMembers/Sacco-B/Details', icon: <Users size={24} />, color: 'bg-red-500' },

    // ─────────────────────────────────────────────
    // Financial
    { label: 'Members Savings', path: '/Members/Sacco-All/Savings', icon: <PiggyBank size={24} />, color: 'bg-emerald-500' },
    { label: 'Loan Requests', path: '/loanRequests/All', icon: <Files size={24} />, color: 'bg-orange-500' },
    { label: 'Loan Payments', path: '/Members/Sacco-All/LoanPayments', icon: <CreditCard size={24} />, color: 'bg-purple-500' },
    { label: 'Members Shares', path: '/Members/Sacco-All/Shares', icon: <Combine size={24} />, color: 'bg-indigo-500' },
    { label: 'Members Welfare', path: '/Members/Sacco-All/Welfare', icon: <Group size={24} />, color: 'bg-pink-500' },
    { label: 'Office Income', path: '/Members/Sacco-All/OfficeIncome', icon: <FileUp size={24} />, color: 'bg-yellow-500' },
    { label: 'Sacco Expenses', path: '/Expenses', icon: <Sheet size={24} />, color: 'bg-red-500' },
    { label: 'Member Vehicles', path: '/Vehicles', icon: <Truck size={24} />, color: 'bg-cyan-500' },
    { label: 'Insurance Payment', path: '/Insurance', icon: <WalletCards size={24} />, color: 'bg-violet-500' },
    { label: 'Sacco Sales', path: '/Sales', icon: <BadgePercent size={24} />, color: 'bg-teal-500' },

    // ─────────────────────────────────────────────
    // Revenue Reports
    { label: 'Daily Reports', path: '/daily-reports', icon: <HandCoins size={24} />, color: 'bg-amber-500' },
    { label: 'Loan Form Sales', path: '/Revenue-Filter/LoanForm', icon: <CalendarCheck size={24} />, color: 'bg-blue-500' },
    { label: 'Loan Interests', path: '/Revenue-Filter/LoanInterests', icon: <CalendarCheck size={24} />, color: 'bg-purple-600' },
    { label: 'Registration Revenue', path: '/Revenue-Filter/RegistrationRevenue', icon: <CalendarCheck size={24} />, color: 'bg-green-600' },
    { label: 'Sales Revenue', path: '/Revenue-Filter/SalesRevenue', icon: <CalendarCheck size={24} />, color: 'bg-teal-600' },
    { label: 'Defaulters Revenue', path: '/Revenue-Filter/DefaultersRevenue', icon: <CalendarCheck size={24} />, color: 'bg-red-600' },

    // ─────────────────────────────────────────────
    // Accounting Reports (uncommented in your sidebar)
    { label: 'Chart Of Accounts', path: '/chart-of-accounts', icon: <BarChart size={24} />, color: 'bg-lime-500' },
    { label: 'Trial Balances', path: '/trial-balance', icon: <ArrowRightLeft size={24} />, color: 'bg-sky-500' },
  ];

  const handleNavClick = (item) => {
    if (item.key === 'menu' || item.key === 'members') {
     // setShowModal(true);
       navigate(item.path);
    }else if (item.key === 'Shop' || item.key === 'shop') {
         navigate(item.path+'/all');
    }
     else {
      navigate(item.path);
      //setActiveTab(item.key);
    }
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    setShowModal(false);
  };

  return (
    <>
      {/* Bottom Navigation Bar */}
      <div className="fixed bottom-0 md:hidden left-0 right-0 z-50 bg-white ">
        <div className="flex justify-around items-center h-16">
          {navItems.map((item) => (
            <button
              key={item.key}
              onClick={() => handleNavClick(item)}
              className={`flex flex-col items-center text-xs font-medium transition-all duration-200 ${
                activeTab === item.key
                  ? 'text-orange-600 scale-110'
                  : 'text-gray-900 hover:text-blue-500'
              }`}
            >
              {item.icon}
              <span className="mt-1">{item.name}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Full Screen Premium Menu Modal */}
      {showModal && (
        <div className="fixed inset-0 z-[60] bg-white overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-5 border-b border-gray-200 bg-gradient-to-r from-indigo-50 to-blue-50">
            <h2 className="text-xl font-bold text-gray-900">All Features</h2>
            <button
              onClick={() => setShowModal(false)}
              className="p-2 rounded-full hover:bg-gray-200 transition-colors"
            >
              <X size={28} className="text-gray-700" />
            </button>
          </div>

          {/* Menu Items Grid */}
          <div className="p-5 overflow-y-auto" style={{ height: 'calc(100vh - 80px)' }}>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
              {premiumMenuItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => handleMenuItemClick(item.path)}
                  className="group relative overflow-hidden rounded-2xl bg-white border border-gray-200 p-5 text-left transition-all duration-300 hover:shadow-xl hover:scale-[1.03] active:scale-95"
                >
                  {/* Icon Background */}
                  <div className={`inline-flex items-center justify-center w-14 h-14 rounded-2xl ${item.color} text-white mb-4 shadow-md group-hover:scale-110 transition-transform duration-300`}>
                    {item.icon}
                  </div>
                  
                  {/* Label */}
                  <h3 className="font-semibold text-gray-900 text-sm leading-tight group-hover:text-blue-600 transition-colors">
                    {item.label}
                  </h3>
                  
                  {/* Subtle hover overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 to-purple-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl pointer-events-none" />
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
}